import _ from "lodash"
import { defineStore } from "pinia"

import ApiService from "@/lib/api_service"

export const useChatStore = defineStore("chatStore", {
  state: () => ({
    chats: [],
    maxDocuments: -1
  }),

  getters: {
    getChat: (state) => {
      return (key) => {
        let chat = state.chats.find((chat) => chat.key === key)

        if (!chat) {
          chat = {
            init: false,
            key: key,
            doc_ids: [],
            messages: [],
            isLoading: false
          }

          state.chats.push(chat)
        }

        return chat
      }
    }
  },

  actions: {
    updateDocIds(chatKey, docIds) {
      const storeChat = this.getChat(chatKey)
      storeChat.doc_ids = docIds
    },

    async fetchMessages(chatKey, callback = null) {
      const storeChat = this.getChat(chatKey)
      if (storeChat.isLoading) return

      storeChat.isLoading = true

      ApiService.fetchMessages(
        {
          key: chatKey
        },
        (response) => {
          this.maxDocuments = response.max_documents

          storeChat.messages = response.messages.map(message => {
            return {
              ...message,
              body: message.content
            }
          })
          storeChat.init = true

          storeChat.isLoading = false

          if (callback) callback()
        }
      )
    },

    async createMessage(chatKey, message, callback = null) {
      const storeChat = this.getChat(chatKey)
      storeChat.isLoading = true

      const userMessage = {
        id: (storeChat.messages.length + 1).toString(),
        role: "user",
        body: message,
        timestamp: new Date()
      }
      storeChat.messages.push(userMessage)

      const assistantMessage = { id: (storeChat.messages.length + 1).toString(), body: "", role: "assistant" }
      storeChat.messages.push(assistantMessage)

      ApiService.createMessage(
        {
          key: chatKey,
          timestamp: userMessage.timestamp,
          body: userMessage.body,
          doc_ids: storeChat.doc_ids
        },
        (response) => {
          if (response.status.toUpperCase() === "OK") {
            message = response.message
            assistantMessage.id = message.id
            assistantMessage.body = message.content
            assistantMessage.timestamp = new Date()
          } else {
            assistantMessage.body = "Errore! Riprova."
          }
          storeChat.isLoading = false

          if (callback) callback()
        }
      )
    },

    async deleteChat(chatKey, callback = null) {
      const storeChat = this.getChat(chatKey)
      storeChat.isLoading = true

      ApiService.deleteChat(
        {
          key: chatKey
        },
        (response) => {
          _.remove(this.chats, function (chat) {
            return chat.key === chatKey
          })

          if (callback) callback()
        }
      )
    }
  }
})
